// Shared by the API client and the auth exchange so the base URL cannot
// drift between them.
export const API_BASE = import.meta.env.VITE_LODGE_API_URL || "/lodge/v1";
